export const BANNER_COLUMNS = [
    { field: 'title', headerName: 'Title' },
    { field: 'type', headerName: 'Type' },
    { field: 'isActive', headerName: 'Active' },
    { field: 'targetAllOrgs', headerName: 'Target' },
    { field: 'priority', headerName: 'Priority' },
    { field: 'startsAt', headerName: 'Starts At' },
    { field: 'expiresAt', headerName: 'Expires At' },
    { field: 'createdAt', headerName: 'Created At' },
    { field: 'actions', headerName: '' },
];
